import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AnnualLeaveEntitlementService } from 'app/services/models/annual-leave-entitlement.service';
import { ToastrService } from 'ngx-toastr';
import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-leave-entitlement-dialog',
  templateUrl: './leave-entitlement-dialog.component.html',
  styleUrls: ['./leave-entitlement-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LeaveEntitlementDialogComponent implements OnInit {


  isTotal: boolean = true;
  data: any[] = [];
  searchTerm: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private toastrService: ToastrService,
    private annualService: AnnualLeaveEntitlementService
  ) { }

  async ngOnInit() {
  }

  async loadData() {
    try {
      const response = await this.annualService.getTheRemainingAnnualLeaveEntitlementOfTheStaff(this.isTotal, this.searchTerm);
      if (response && response.length > 0) {
        this.data = response;
      } else {
        this.data = [];
        this.toastrService.info('Kalan yıllık izin bilgisi bulunamadı.');
      }
    } catch (error) {
      this.toastrService.error('Veriler alınırken hata oluştu.');
    }
  }

  async onIsTotalChange() {
    await this.loadData();
  }

  close() {
    this.activeModal.close();
  }

  exportExcel(): void {
    if (!this.data || this.data.length === 0) {
      this.toastrService.info('Dışa aktarılacak veri bulunamadı.');
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Kalan Yıllık İzinler');

    // isTotal durumuna göre exportData oluştur
    let exportData;
    if (this.isTotal) {
      exportData = this.data.map((d: any) => ({
        'Sicil No': d.registrationNumber,
        'Ad Soyad': d.fullName,
        'Departman': d.departmant,
        'Yıl': d.year,
        'Hak Edilen': this.parseSafeNumber(d.entitledDays),
        'Kalan Gün': this.parseSafeNumber(d.remainingDays),
      }));
    } else {
      // Eğer isTotal false ise, farklı yapı varsa uyarlayabilirsin
      exportData = this.data.map((d: any) => ({
        'Sicil No': d.registrationNumber,
        'Ad Soyad': d.fullName,
        'Departman': d.departmant,
        'Yıl': d.year,
        'Hak Edilen': this.parseSafeNumber(d.entitledDays),
        'Kalan Gün': this.parseSafeNumber(d.remainingDays),
        // İstersen başka alanlar ekleyebilirsin
      }));
    }

    // Sütun başlıkları
    const headers = Object.keys(exportData[0]);
    worksheet.columns = headers.map(header => ({
      header,
      key: header,
      width: 20,
    }));

    // Satırları ekle
    exportData.forEach(row => worksheet.addRow(row));

    // Başlık satırı yüksekliği
    worksheet.getRow(1).height = 30;

    // Sütun genişliklerini ayarla (içeriğe göre)
    worksheet.columns.forEach(column => {
      let maxLength = 1;
      column.eachCell({ includeEmpty: true }, cell => {
        const val = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, val.length);
      });
      column.width = maxLength + 2;
    });

    // Başlık hücrelerini stil ver
    worksheet.getRow(1).eachCell(cell => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF256CA6' }, // Açık mavi
      };
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    // Dosyayı kaydet
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      const fileName = `Kalan_Yillik_Izinler_${this.isTotal ? 'Toplam' : 'Yillik'}_${new Date().getFullYear()}.xlsx`;
      FileSaver.saveAs(blob, fileName);
    });
  }

  parseSafeNumber(value: any): number {
    if (typeof value === 'string') {
      value = value.replace(',', '.');
    }
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }
  
}
